<ion-grid class="confirmation-body">
  <ion-row>
    <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" *ngIf="moduleName==1">
      <ng-multiselect-dropdown class="ml-5 w-100"
        [placeholder]="'Select Department'"
        [settings]="dropdownSettings" 
        [data]="getStatusList"
        [(ngModel)]="selectedSatus" 
        (onSelect)="onSelectStatus()"
        (onDeSelect)="onDeSelectStatus()"
        (onSelectAll)="selectAllStatus($event)"
        (onDeSelectAll)="onDeSelectAllStatus()">
      </ng-multiselect-dropdown>
    </ion-col> -->
    <ion-col>
      <div class="center-content justify-content-flex-end">

        <div class="center-content justify-content-flex-end" *ngIf="(moduleName!=1&&  moduleName!=2 && moduleName!=3&& moduleName!='Manager')">
          <label class="mr-10" >Not Recived Asset</label>
          <mat-slide-toggle class="mr-10"  *ngIf="(moduleName!=1&& moduleName!=3&& moduleName!=2)"[(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
          <label class="mr-10" >Recived Asset</label>
        
        
        </div>
        <button (click)="exportDashboardListExcel()" class="mr-10 Download fs-16 font_semibold">
          <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
        </button>
        <div class="close_bg display-center cp" [mat-dialog-close]>
          <img src="././assets/icon/close_icon.png" class="closeHeight">
        </div>
      </div>
    </ion-col>
  </ion-row>
 
  <!-- Scrollable Table -->
  <ion-row>
    <ion-col class="p-10" size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="table-container">
        
        <table class="table-scroll" *ngIf="moduleName==1">
          <thead>
            <tr>
              <th> Asset</th> 
              <th> Band</th>  
              <th> Employee Name</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of allDataForDispay; let rowId = index">
              <td>{{row.assetName}}</td>
              <td>{{row.band}}</td>
              <td>{{ row.employeeName }}</td>
              
            </tr>
          </tbody>
        </table>
        <table class="table-scroll" *ngIf="moduleName==2">
          <thead>
            <tr>
           
              <th> Employee Name</th> 
              <th>Unassigned  Asset</th> 
              <th> Date Of Joining</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of newAssetListingData; let rowId = index">
              <td>{{ row.employeeName }}</td>
              <td>{{row.unassignedAssets}}</td>
              <td>{{row.dateOfJoining|date:"dd/MM/yyyy"}}</td>
              
            </tr>
          </tbody>
        </table>
        <table class="table-scroll" *ngIf="moduleName==3">
          <thead>
            <tr>
           
              
              <th> Asset</th> 
              <th> Number Off Time Repaired Asset
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of repairedAsset; let rowId = index">
              
              <td>{{row.assetName}}</td>
              <td>{{row.statusChangeCount}}</td>
              
            </tr>
          </tbody>
        </table>
        <table class="table-scroll" *ngIf="moduleName==4">
          <thead>
            <tr>
            <th> Asset</th> 
            <th> Employee Name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of returnAsset; let rowId = index">
              <td>{{row.assetName}}</td>
              <td>{{row.employeeName}}</td>
             </tr>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
